import React, { Component } from "react";
import { Modal, Form, Input, InputNumber, Select } from "antd";

import http from "../../../axios/http";
import server from "../../../axios/server";
const FormItem = Form.Item;

class FeeRuleEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      parkZones: [],
    };
  }

  save = () => {
    const { editData, form } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      if (editData.id) values["id"] = editData.id;
      http.post({
        url: "/barrier/feeRule/save",
        data: values,
        success: (res) => {
          http.post({
            url:
              server.mallServerUrl + "/externalApi/barrier/updateFeeRuleCache",
            data: {},
            success: (res) => {
              console.log("mallapi收费规则刷新成功");
            },
          });
          this.props.successCallback(this.props.queryData);
          this.props.onCancel();
        },
      });
    });
  };

  isOutClick = () => {
    const editData = this.props.editData;
    const form = this.props.form;
    form.isOut = editData.isOut = !editData.isOut;
  };

  loadParkZone = () => {
    http.post({
      url: "/barrier/parkZone/allZone",
      success: (res) => {
        this.setState({ parkZones: res });
      },
    });
  };

  componentWillMount() {
    this.loadParkZone();
  }

  render() {
    const { visible, onCancel, form, editData } = this.props;
    const { getFieldDecorator } = form;
    const { parkZones } = this.state;
    return (
      <Modal
        visible={visible}
        title="收费规则编辑"
        okText="保存"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        onOk={this.save}
        afterClose={() => {
          this.props.form.resetFields();
        }}
      >
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 15 }}
        >
          <FormItem label="ID：">
            {getFieldDecorator("id", {
              rules: [],
              initialValue: editData.id,
            })(<Input readOnly />)}
          </FormItem>
          <FormItem label="名称：">
            {getFieldDecorator("name", {
              rules: [
                { required: true, message: "请输入收费规则名称!" },
                { max: 32, message: "最多只能输入32个字符！" },
              ],
              initialValue: editData.name,
            })(<Input />)}
          </FormItem>
          <FormItem label="生效区域：">
            {getFieldDecorator("zone", {
              initialValue: editData.zone,
            })(
              <Select>
                <Select.Option value="">无</Select.Option>
                {parkZones &&
                  parkZones.map((item, index) => (
                    <Select.Option value={item.code}>{item.name}</Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>
          <FormItem label="免费时长">
            {getFieldDecorator("freeMinute", {
              initialValue: editData.freeMinute || 0,
            })(<InputNumber min={0} />)}
            {"分钟"}
          </FormItem>
          <FormItem label="起收价格">
            {getFieldDecorator("startFee", {
              initialValue: editData.startFee || 0,
            })(<InputNumber min={0} />)}
            {"元"}
          </FormItem>
          <FormItem label="每小时递增">
            {getFieldDecorator("stepFee", {
              initialValue: editData.stepFee || 0,
            })(<InputNumber min={0} />)}
            {"元"}
          </FormItem>
          <FormItem label="每日封顶">
            {getFieldDecorator("capFee", {
              initialValue: editData.capFee || 0,
            })(<InputNumber min={0} />)}
            {"元"}
          </FormItem>
          <FormItem label="月租价格">
            {getFieldDecorator("monthFee", {
              initialValue: editData.monthFee || 0,
            })(<InputNumber min={0} />)}
            {"元"}
          </FormItem>
          <FormItem label="收费类型：">
            {getFieldDecorator("state", {
              initialValue: editData.state || 0,
            })(
              <Select>
                <Select.Option value={0}>正式收费</Select.Option>
                <Select.Option value={10}>收费测试</Select.Option>
                <Select.Option value={99}>虚拟计费</Select.Option>
              </Select>
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const FeeRuleEdit = Form.create()(FeeRuleEditForm);

export default FeeRuleEdit;
